import { SubscriptionBase } from '@Base/Engagement/SubscriptionBase';

import "./Subscription.scss";

export class Subscription extends SubscriptionBase
{
	constructor()
	{
		super();
	}

	public override get GenericText(): string
	{
		return '<div class="subscribe__val">SIGN UP</div><div class="subscribe__fir">For Our Email Club &amp; Receive <br /> Exclusive Deals &amp; Gift Ideas!</div>';
	}

	public override get GenericThanks(): string
	{
		return '<span class="subscribe__sent">Exclusive Deals &amp; Gift Ideas Are on Their Way to</span>';
	}
}